import React from 'react';

import BaseWidget from '../base-widget/BaseWidget';
import {SchemaContext} from "../../schema/context/SchemaContext";
import Loader from "../../loader/Loader";
import Table from "react-bootstrap/Table";
import OpenSchemaValidationAction from "../../schema/actions/OpenSchemaValidationAction";
import {DataValidationReport} from "../../../services/models/validation-model";

type ValidationStatusWidgetProps = {
  schemaId?: string;
  loading?: boolean;
  error?: any;
}

class ValidationStatusWidget extends React.Component<ValidationStatusWidgetProps> {

  static contextType = SchemaContext;

  componentDidMount() {
    this.context.pollDataValidationStatus(this.props.schemaId || '');
  }

  componentWillUnmount(): void {
    this.context.stopValidationStatusPolling();
  }

  render() {
    const schemaId: string | undefined = this.props.schemaId;
    const report: DataValidationReport = this.context.dataValidationReport;
    if (!report) {
      return null;
    }

    return (
      <BaseWidget className="ValidationStatusWidget" title='Data Validation Status'>
        {
          this.context.loading && <Loader size='lg' block={true}/>
        }
        {
          !this.context.loading && this.context.schema &&
          <ValidationStatusView validationReport={report} schemaId={schemaId} inProgress={this.context.isDataValidationRunning}/>
        }
      </BaseWidget>
    );
  }
}

function DataValidationProgress() {
  return (
    <div className="validation-progress">
      <span>Validation is in progress </span>
      <Loader size='sm'/>
      <hr/>
    </div>
  );
}

function ValidationStatusView(props: { validationReport: DataValidationReport, inProgress: boolean, schemaId?: string }) {
  const {validationReport, inProgress, schemaId} = props;

  const reportFieldRenderer: {[key: string]: any} = {
    createdOn: <>
      <td>Created on</td>
      <td className="createdOn">{validationReport.createdOn}</td>
    </>,
    completedOn: <>
      <td>Completed on</td>
      <td className="completedOn">{validationReport.completedOn}</td>
    </>,
    canceledOn: <>
      <td>Canceled on</td>
      <td className="canceledOn">{validationReport.canceledOn}</td>
    </>,
    totalTasksCount: <>
      <td>Total tasks</td>
      <td className="totalTasks">{validationReport.totalTasksCount}</td>
    </>,
    remainingTasksCount: <>
      <td>Remaining tasks</td>
      <td className="remainingTasks">{validationReport.remainingTasksCount}</td>
    </>,
    infoTasksCount: <>
      <td>Info tasks</td>
      <td className="remainingTasks">{validationReport.infoTasksCount}</td>
    </>,
    warningTasksCount: <>
      <td>Warning tasks</td>
      <td className="warningTasks">{validationReport.warningTasksCount}</td>
    </>,
    failedTasksCount: <>
      <td>Failed tasks</td>
      <td className="failedTasks">{validationReport.failedTasksCount}</td>
    </>,
    status: <>
      <td>Status</td>
      <td className="status">{validationReport.status}</td>
    </>
  };

  const validationReportProps = validationReport as {[key: string]: any};
  return <>
    {
      inProgress && <DataValidationProgress/>
    }
    <Table size="sm" borderless hover>
      <tbody>
      {
        Object.keys(validationReportProps).map((propertyName) => {
          if (validationReportProps[propertyName]) {
            return (<tr key={propertyName}>{reportFieldRenderer[propertyName]}</tr>)
          }
          return null;
        })
      }
      </tbody>
    </Table>
    {
      validationReport.done && <OpenSchemaValidationAction schemaId={schemaId} disabled={false}/>
    }
  </>
}

export default ValidationStatusWidget;
